var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomOutOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 17C7.54386 17 5 14.4561 5 11C5 7.54386 7.54386 5 11 5C14.4561 5 17 7.54386 17 11C17 14.4561 14.4561 17 11 17ZM11 19C15.4386 19 19 15.4386 19 11C19 6.5614 15.4386 3 11 3C6.5614 3 3 6.5614 3 11C3 15.4386 6.5614 19 11 19ZM20.7018 19.2982L16.7018 15.2982C16.5263 15.1053 16.2807 15 16 15C15.4561 15 15 15.4561 15 16C15 16.2807 15.1053 16.5263 15.2982 16.7018L19.2982 20.7018C19.4737 20.8947 19.7193 21 20 21C20.5439 21 21 20.5439 21 20C21 19.7193 20.8947 19.4737 20.7018 19.2982ZM8 12H14C14.5439 12 15 11.5439 15 11C15 10.4561 14.5439 10 14 10H8C7.45614 10 7 10.4561 7 11C7 11.5439 7.45614 12 8 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOutOutlined);
export default __webpack_public_path__ + "static/media/zoom_out_outlined.02505c7d.svg";
export { ForwardRef as ReactComponent };